import type { TaskLog } from '../types';

interface TaskLogModalProps {
  isOpen: boolean;
  onClose: () => void;
  logs: TaskLog[];
  taskName: string;
}

export default function TaskLogModal({ isOpen, onClose, logs, taskName }: TaskLogModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">
            任务执行日志 - {taskName}
          </h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-4">
            {logs.map((log) => (
              <div
                key={log.id}
                className={`border rounded-lg p-4 ${
                  log.result === 'success'
                    ? 'border-green-200 bg-green-50'
                    : 'border-red-200 bg-red-50'
                }`}
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                        log.result === 'success' ? 'bg-green-600' : 'bg-red-600'
                      }`}
                    >
                      <i
                        className={`ri-${
                          log.result === 'success' ? 'checkbox-circle' : 'close-circle'
                        }-line text-white text-xl`}
                      ></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">
                        {log.result === 'success' ? '执行成功' : '执行失败'}
                      </div>
                      <div className="text-sm text-gray-600">{log.executionTime}</div>
                    </div>
                  </div>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      log.result === 'success'
                        ? 'bg-green-100 text-green-700'
                        : 'bg-red-100 text-red-700'
                    }`}
                  >
                    {log.result === 'success' ? '成功' : '失败'}
                  </span>
                </div>

                <div className="grid grid-cols-3 gap-4 text-sm">
                  <div>
                    <span className="text-gray-600">执行耗时：</span>
                    <span className="font-medium text-gray-900">{log.duration}</span>
                  </div>
                  <div>
                    <span className="text-gray-600">处理数据量：</span>
                    <span className="font-medium text-gray-900">{log.processedCount}</span>
                  </div>
                  <div>
                    <span className="text-gray-600">日志ID：</span>
                    <span className="font-medium text-gray-900">{log.id}</span>
                  </div>
                </div>

                {log.errorMessage && (
                  <div className="mt-3 pt-3 border-t border-red-200">
                    <div className="text-xs font-semibold text-red-700 mb-1">错误信息</div>
                    <div className="text-sm text-red-800 bg-red-100 rounded p-2">
                      {log.errorMessage}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gray-50 px-6 py-4 flex items-center justify-end border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-white border border-gray-300 text-gray-700 text-sm rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            关闭
          </button>
        </div>
      </div>
    </div>
  );
}
